import * as Yup from "yup";
import { forgotPasswordService } from "../../services/authServices.js";
import Alert from "../../utils/Alert.js";

export const initialValues = {
    email_or_phone: "",
    new_password: "",
    confirm_password: ""
};

export const onSubmit = async (values, actions, navigate) => {
    try {
        const response = await forgotPasswordService(values);
        if (response.status === 200) {
            await Alert("رمز عبور تغییر یافت", null, "success");
            return navigate("/auth/login");
        }
    } catch (error) {
        if (error.response && error.response.status === 404) {
            Alert(`خطا ${error.response.status}!`, "کاربری با این مشخصات یافت نشد", "error")
        }
    }
}

export const validationSchema = Yup.object({
    email_or_phone: Yup.string().required("لطفاً ایمیل یا شماره تلفن را وارد کنید")
        .matches(/(^[a-zA-Z0-9._-]+@[a-zA-Z.]+\.[a-zA-Z]{2,}$)|(^[0-9]{11}$)/, "لطفاً یک ایمیل یا شماره تلفن معتبر وارد کنید"),
    new_password: Yup.string().required("لطفاً رمز عبور را وارد کنید")
        .matches(/^[a-zA-Z0-9_]+$/, "داخل رمز از نمادها و فاصله استفاده نکنید"),
    confirm_password: Yup.string().required("لطفاً تکرار رمز عبور را وارد کنید")
        .oneOf([Yup.ref("new_password")], "با رمز عبور مطابقت ندارد")
});